const options = {
  5: "bg-sky-800/5",
  10: "bg-sky-800/10",
  25: "bg-sky-800/25",
  50: "bg-sky-800/50",
  75: "bg-sky-800/75",
  90: "bg-sky-800/90",
  100: "bg-sky-800",
};

const from = {
  5: "from-sky-800/5",
  10: "from-sky-800/10",
  25: "from-sky-800/25",
  50: "from-sky-800/50",
  75: "from-sky-800/75",
  90: "from-sky-800/90",
  100: "from-sky-800",
};

export default function getBackgroundSky800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
